export { EmailForm, useEmailValidation } from './element'

export interface IValid {
  isValid: true
}

export interface IInvalid {
  isValid: false
  errorText: string
}

export interface IProps {
  size?: 'large' | 'small'
  buttonText?: string
  inputRef?: React.RefObject<HTMLInputElement>
  loading?: boolean
  onChange: (value: string) => void
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  placeholderText?: string
  small?: boolean
  validity: IValid | IInvalid
  value?: string
  onFormFocus?: () => void
}
